import { Injectable } from "@angular/core";
import { Observable, timer, takeWhile, filter, takeUntil, endWith, switchMap, of, tap } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class UtilityService {
  /**
   * Wait until an object is fully created.
   * Use this method if needing to wait until a view child is fully rendered.
   * Use this method instead of a settimeout().
   * @param parent
   * @param viewChildName
   * @param signal : Set to true when waiting for a viewChild signal to be completed.
   * @param refreshRate
   * @param maxWaitTime
   * @returns
   */
  waitUntilObjectIsReady(
    parent: any,
    viewChildName: string = null,
    signal: boolean = true,
    refreshRate: number = 15,
    maxWaitTime: number = 3000
  ): Observable<boolean> {
    return timer(refreshRate, refreshRate).pipe(
      takeWhile(() => !this.isObjectDefined(!signal ? parent[viewChildName] : parent())),
      filter((x) => x === undefined),
      takeUntil(timer(maxWaitTime)),
      endWith(!signal ? parent[viewChildName] : parent()),
      switchMap(() => {
        return of(this.isObjectDefined(!signal ? parent[viewChildName] : parent()));
      })
    );
  }

  isObjectDefined<T>(value: T | undefined | null): boolean {
    return <T>value !== undefined && <T>value !== null && Object.keys(<T>value).length !== 0;
  }

  startWithTap<T>(callback: () => void) {
    return (source: Observable<T>) =>
      of({}).pipe(
        tap(callback),
        switchMap(() => source)
      );
  }

  /**
   * Check if value is numerically 0
   * "000000" = 0
   * 0000000 = 0
   * @param data
   * @returns
   */
  isNumberZero = (data: string | number) => {
    // Unary plus operator converts string to number
    return +data === 0;
  };
}
